import React, { useState } from 'react';
import { Grid, makeStyles, MenuItem, Select, TextField } from '@material-ui/core';
import actionButtons from '../../components/ActionButtons/index.actions.js';

const ActionDropdown = ({ data }) => {
    const { action_dropdown = [] } = data;
    const [selectedAction, setSelectedAction] = useState('resend_latest_message');

    const useStyles = makeStyles(() => ({
        field: {
          marginBottom: 10,
          width: '100%'
        },
        select: {
          width: '100%'
        },
        formControl: {
          width: '100%'
        }
    }));
    const classes = useStyles();
    const onActionSelect = (event) => {
        const action = event.target.value;
        setSelectedAction(action);
    }

    //----
    const ActionButtonComponent =  actionButtons[selectedAction];

    return (
        <>
        <Select
            required={true}
            name="action_dropdown"
            variant='outlined' 
            className={classes.field}
            onChange={onActionSelect}
            value={selectedAction}
          >
            {
                action_dropdown && action_dropdown.length ? action_dropdown?.map(action => {
                    return <MenuItem key={action.value} value={action.action}>
                    {action.label}
                </MenuItem>
            }) : <></>
            }
        </Select>
        {
            selectedAction && actionButtons[selectedAction] && (
                <ActionButtonComponent
                    key={selectedAction}
                    data={data}
                />
            )
        }
        </>
    )
}

export default ActionDropdown;